import { call, put, takeLatest } from 'redux-saga/effects'
import { TDataWrapper, TResponse } from '../types'
import { getAccessToken } from '../user'
import { gridActions } from './actions'
import { ApiBannerService } from './api.service'
import { RESPONSE } from './const'
import {
   TCreateGridBannerPayload,
   TEditGridBannerPayload,
   TRemoveGridBannerPayload,
   TSaveGridBannersPayload
} from './types'
import { ELocales } from 'enums'

function* getBannersWorker({ payload }: TDataWrapper<{ lang: ELocales }>) {
   yield put(gridActions.setBannerState({ loading: true }))

   const token: string = yield call(getAccessToken)

   try {
      const response: TResponse = yield call(
         [ApiBannerService, ApiBannerService.getBanners],
         { token, lang: payload.lang }
      )

      if (response.data.data) {
         yield put(gridActions.setBanners(response.data.data))
      }
   } catch (e) {
      yield put(gridActions.setBanners(null))
   }

   yield put(gridActions.setBannerState({ loading: false }))
}

function* removeBannerWorker({ payload }: TDataWrapper<TRemoveGridBannerPayload>) {
   yield put(gridActions.setBannerState({ loading: true }))

   const { _id } = payload
   const token: string = yield call(getAccessToken)

   try {
      yield call([ApiBannerService, ApiBannerService.removeBanner], { token, _id })
   } catch (e) {}

   yield put(gridActions.setBannerState({ loading: false }))
}

function* saveBannersWorker({ payload }: TDataWrapper<TSaveGridBannersPayload>) {
   yield put(gridActions.setBannerState({ loading: true }))

   const { banners } = payload

   for (const banner of banners) {
      if (banner._id) {
         const { data, _id } = banner
         yield call(editBanner, { data, _id })
      } else {
         const { data } = banner
         yield call(createBanner, { data })
      }
   }

   yield put(gridActions.setBannerState({ loading: false, response: RESPONSE.SAVED }))
}

function* editBanner({ data, _id }: TEditGridBannerPayload) {
   const token: string = yield call(getAccessToken)

   try {
      yield call([ApiBannerService, ApiBannerService.editBanner], { token, data, _id })
   } catch (e) {}
}

function* createBanner({ data }: TCreateGridBannerPayload) {
   const token: string = yield call(getAccessToken)

   try {
      yield call([ApiBannerService, ApiBannerService.createBanner], { token, data })
   } catch (e) {}
}

export function* gridBannerWatcher() {
   yield takeLatest(gridActions.getBanners, getBannersWorker)
   yield takeLatest(gridActions.removeBanner, removeBannerWorker)
   yield takeLatest(gridActions.saveBanners, saveBannersWorker)
}
